"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicContext = void 0;

var react_1 = __importStar(require("react"));

var subscriber_1 = require("./subscriber");

var hooks_1 = require("./hooks");

var subscription_1 = require("./subscriber/subscription");

var re_render_1 = require("./subscriber/re-render");

var equality_functions_1 = require("./equality-functions");

var hook_1 = require("./subscriber/hook");

var EMPTY_VAL = "__$$emptyValue:?#@#y7q!}fmhW)eL}L{b#b^(3$ZAMg.eyp6NL#h<N-S$)L<.=-j3WsMp&%2JDf6_vVdN7K.\"pg\"_aswq\"9CRS?!9YzG[}AD~Xb[E__$$";

var DynamicContext =
/** @class */
function () {
  function DynamicContext(defaultValueGetter, key, options) {
    var _this = this;

    this.defaultValueGetter = defaultValueGetter;
    this.key = key;
    this.InternalHooks = {
      version: 0,
      arr: []
    };

    this.getSubscriberContextDefaultValue = function () {
      var rawValue = _this.useRawValue();

      var finalValue = _this.rawToFinalValueHook(rawValue);

      return _this.selectorArgsHook(finalValue, rawValue);
    };

    this.defValueReRenders = new subscription_1.Subscription();

    this.useRawValue = function () {
      var contextValue = react_1.useContext(_this.mainContext);

      if (contextValue === EMPTY_VAL) {
        re_render_1.useReRenderSubscription(_this.defValueReRenders);
        contextValue = _this.defaultValueGetter();
      }

      if (contextValue === EMPTY_VAL) {
        throw new Error("Dynamic Context without deafult value must be used with provider");
      }

      return contextValue;
    };

    this.Provider = function (props) {
      var Provider = _this.providerHelper;
      return react_1.default.createElement(Provider, __assign({}, props, {
        key: _this.InternalHooks.version
      }));
    };

    this.providerHelper = function (_a) {
      var _b;

      var children = _a.children,
          props = __rest(_a, ["children"]);

      var internalContextData = react_1.useState(_this.subscriberContext.registerNewProvider)[0];
      react_1.useEffect(function () {
        return function () {
          return _this.subscriberContext.destroyIntervalProvider(internalContextData.id);
        };
      }, []);
      var RawProvider = _this.RawProvider;

      var rawValue = _this.useReconstructValue(props);

      var finalValue = _this.rawToFinalValueHook(rawValue);

      var contextSelectorArgs = _this.selectorArgsHook(finalValue, rawValue);

      (_b = _this.subscriberContext).updateLastProviderValue.apply(_b, __spreadArrays([internalContextData.id], contextSelectorArgs));

      var lastChildren = children;

      for (var _i = 0, _c = _this.InternalHooks.arr; _i < _c.length; _i++) {
        var el = _c[_i];
        var Provider = el.dynamicContext.Provider;
        var val = el.hook(finalValue);
        lastChildren = react_1.default.createElement(Provider, {
          value: val
        }, lastChildren);
      }

      var Int = _this.subscriberContext.context.Provider;
      return react_1.default.createElement(Int, {
        value: internalContextData
      }, react_1.default.createElement(RawProvider, __assign({}, props), lastChildren));
    };

    this.useValue = function () {
      var rawValue = _this.useRawValue();

      return _this.rawToFinalValueHook(rawValue);
    };

    this.useProperty = function (key) {
      return _this.useSelector(function (val) {
        return val[key];
      }, []);
    };

    this.useProperties = function () {
      var keys = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
      }

      return _this.useSelector(function (val) {
        return pickKeys(val, keys);
      }, topPropsEquality, []);
    };

    if (key === "undefined") {
      key = "value";
      this.key = key;
    }

    this.mainContext = react_1.default.createContext(EMPTY_VAL);
    this.defaultValueGetter = defaultValueGetter;
    var rawToFinalValueHook = options ? options.rawToFinalValueHook : undefined;

    this.rawToFinalValueHook = rawToFinalValueHook || function (x) {
      return x;
    };

    this.RawProvider = this.getRawProvider();
    var selectorArgsEqualityFn = options ? options.selectorArgsEqualityFn : undefined;
    var selectorValueEqualityFn = options && options.selectorValueEqualityFn;
    var selectorArgsHook = options ? options.selectorArgsHook : undefined;

    if (!selectorArgsHook) {
      selectorArgsEqualityFn = defaultContextSelectorArgsEqualityFn;
    }

    this.selectorArgsHook = selectorArgsHook || defaultUseContextSelectorArgs;
    this.subscriberContext = new subscriber_1.ContextSubscriber(this.getSubscriberContextDefaultValue, selectorArgsEqualityFn);
    this.useSelector = this.subscriberContext.useSelector;

    if (selectorValueEqualityFn) {
      this.useSelector.setEqualityFn(selectorValueEqualityFn);
    }
  }

  DynamicContext.prototype.setContextName = function (name) {
    this.mainContext.displayName = name;
  };

  DynamicContext.prototype.setDefaultValue = function (rawValue) {
    var _this = this;

    this.defaultValueGetter = function () {
      return rawValue;
    };

    this.subscriberContext.setDefaultValueGetter(function () {
      return _this.getSubscriberContextDefaultValue();
    });
    this.defValueReRenders.broadcast();
  };

  DynamicContext.prototype.setDefaultValueGetter = function (fn) {
    var _this = this;

    this.defaultValueGetter = fn;
    this.subscriberContext.setDefaultValueGetter(function () {
      return _this.getSubscriberContextDefaultValue();
    });
    this.defValueReRenders.broadcast();
  };

  DynamicContext.prototype.useReconstructValue = function (props) {
    if (typeof this.key === "string") {
      return props[this.key];
    }

    return hooks_1.usePropsMemo(function () {
      return props;
    }, [props]);
  };

  DynamicContext.prototype.addInternalContext = function (hook, displayName) {
    var _this = this;

    this.InternalHooks.version++;

    var valueGetter = function valueGetter() {
      return hook(_this.useValue());
    };

    var selectorValueEqualityFn = hook_1.dublicateEqualityFn(this.useSelector);
    var dynamicContext = new DynamicContext(valueGetter, "value", {
      selectorValueEqualityFn: selectorValueEqualityFn
    });
    dynamicContext.setContextName(displayName);
    var el = {
      hook: hook,
      dynamicContext: dynamicContext
    };
    this.InternalHooks.arr.unshift(el);

    var destroy = function destroy() {
      var index = _this.InternalHooks.arr.indexOf(el);

      if (index === -1) return;
      _this.InternalHooks.version++;

      _this.InternalHooks.arr.splice(index, 1);
    };

    dynamicContext.destroy = destroy;
    return dynamicContext;
  };

  DynamicContext.prototype.getRawProvider = function () {
    var _this = this;

    var RawContextProvider = this.mainContext.Provider;
    if (this.key === "value") return RawContextProvider;

    if (typeof this.key === "string") {
      var Provider_1 = function Provider_1(props) {
        var value = props[_this.key];
        var children = props.children;
        return react_1.default.createElement(RawContextProvider, {
          value: value
        }, children);
      };

      return Provider_1;
    }

    var Provider = DynamicContext.createDestructuredProvider(this.mainContext);
    return Provider;
  };

  DynamicContext.create = function (defaultValue, key, options) {
    if (key === void 0) {
      key = "value";
    }

    var valueGetter = function valueGetter() {
      return defaultValue === undefined ? EMPTY_VAL : defaultValue;
    };

    return new DynamicContext(valueGetter, key, options);
  };

  DynamicContext.createDestructured = function (defaultValue, options) {
    var valueGetter = function valueGetter() {
      return defaultValue === undefined ? EMPTY_VAL : defaultValue;
    };

    return new DynamicContext(valueGetter, null, options);
  };

  DynamicContext.createDestructuredProvider = function (RawContext) {
    var Provider = function Provider(_a) {
      var children = _a.children,
          rest = __rest(_a, ["children"]);

      var oldValueRef = react_1.useRef(rest);
      var newVal = areEqual(oldValueRef.current, rest) ? oldValueRef.current : rest;

      if (newVal !== oldValueRef.current) {
        oldValueRef.current = newVal;
      }

      return react_1.default.createElement(RawContext.Provider, {
        value: newVal
      }, children);
    };

    return Provider;
  };

  return DynamicContext;
}();

exports.DynamicContext = DynamicContext;

var areEqual = function areEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  var obj1Keys = Object.keys(obj1);
  var obj2Keys = Object.keys(obj2);
  if (obj1Keys.length !== obj2Keys.length) return false;

  for (var i = 0; i < obj1Keys.length; i++) {
    if (obj1Keys[i] !== obj2Keys[i] || obj1[obj1Keys[i]] !== obj2[obj2Keys[i]]) {
      return false;
    }
  }

  return true;
};

var defaultUseContextSelectorArgs = function defaultUseContextSelectorArgs(value, rawValue) {
  var rawValueRef = react_1.useRef(rawValue);
  rawValueRef.current = rawValue;
  return [value, function () {
    return rawValueRef.current;
  }];
};

var defaultContextSelectorArgsEqualityFn = function defaultContextSelectorArgsEqualityFn(prevVal, newVal) {
  return prevVal[0] === newVal[0];
};

function pickKeys(obj, keys) {
  var obj2 = {};

  for (var i = 0; i < keys.length; ++i) {
    if (obj.hasOwnProperty(keys[i]) || obj[keys[i]] !== undefined) {
      obj2[keys[i]] = obj[keys[i]];
    }
  }

  return obj2;
}

var topPropsEquality = function topPropsEquality(obj1, obj2) {
  return equality_functions_1.areDeeplyEqual(obj1, obj2, 1);
};